const translations = {
    courseConductedBy: {
        type: 'text',
        defaultValue: 'Kurs prowadzony przez:',
    },
    courseDatesHeader: {
        type: 'text',
        defaultValue: 'Terminy',
    },
    onlineLabel: {
        type: 'text',
        defaultValue: 'ONLINE',
    },
    offlineLabel: {
        type: 'text',
        defaultValue: 'OFFLINE',
    },
    courseDateCtaButton: {
        type: 'text',
        defaultValue: 'Zapisz się',
    },
    alreadyScheduledButton: {
        type: 'text',
        defaultValue: 'Jesteś zapisany',
    },
};

export default translations;
